import { render } from "./DsoRiderEmailVerification.vue?vue&type=template&id=878cb09c&scoped=true"
import script from "./DsoRiderEmailVerification.vue?vue&type=script&lang=js"
export * from "./DsoRiderEmailVerification.vue?vue&type=script&lang=js"

import "./DsoRiderEmailVerification.vue?vue&type=style&index=0&id=878cb09c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-878cb09c"]])

export default __exports__